import mock from "../mock";

export const searchResult = [
  {
    id: 1,
    target: "AnalyticsDashboard",
    titleEn: "",
    titleId: "",
    title: "Analytics Dashboard",
    link: "/",
    icon: "Home",
    starred: false,
  },
  {
    id: 2,
    target: "eCommerceDashboard",
    titleEn: "",
    titleId: "",
    title: "eCommerce Dashboard",
    link: "/ecommerce-dashboard",
    icon: "Home",
    starred: false,
  },
  {
    id: 3,
    target: "Todo",
    titleEn: "QuickTask",
    titleId: "Tugas Cepat",
    title: "المعاملات",
    link: "/todo/all",
    icon: "CheckSquare",
    starred: true,
  },
  {
    id: 4,
    target: "Chat",
    titleEn: "Chat",
    titleId: "Percakapan",
    title: "المحادثة",
    link: "/chat",
    icon: "MessageSquare",
    starred: true,
  },
  {
    id: 5,
    target: "Email",
    titleEn: "Email",
    titleId: "Pesan",
    title: "البريد الإكتروني",
    link: "/email/inbox",
    icon: "Mail",
    starred: true,
  },
  {
    id: 6,
    target: "Calender",
    titleEn: "Calender",
    titleId: "Kalender",
    title: "التقويم",
    link: "/calendar",
    icon: "Calendar",
    starred: true,
  },
  {
    id: 7,
    target: "E-commerceShop",
    titleEn: "",
    titleId: "",
    title: "E-commerce Shop",
    link: "/ecommerce/shop",
    icon: "ShoppingCart",
    starred: false,
  },
  {
    id: 8,
    target: "E-commerceWishList",
    titleEn: "",
    titleId: "",
    title: "E-commerce Wish List",
    link: "/ecommerce/wishlist",
    icon: "Heart",
    starred: false,
  },
  {
    id: 9,
    target: "E-commerceCheckout",
    titleEn: "",
    titleId: "",
    title: "E-commerce Checkout",
    link: "/ecommerce/checkout",
    icon: "CreditCard",
    starred: false,
  },
  {
    id: 12,
    target: "Grid",
    titleEn: "",
    titleId: "",
    title: "Content - Grid",
    link: "/ui-element/grid",
    icon: "Grid",
    starred: false,
  },
  {
    id: 13,
    target: "Typography",
    titleEn: "",
    titleId: "",
    title: "Content - Typography",
    link: "/ui-element/typography",
    icon: "Type",
    starred: false,
  },
  {
    id: 14,
    target: "TextUtilities",
    titleEn: "",
    titleId: "",
    title: "Content - Text Utilities",
    link: "/ui-element/textutilities",
    icon: "Type",
    starred: false,
  },
  {
    id: 15,
    target: "SyntaxHighlighter",
    titleEn: "",
    titleId: "",
    title: "Content - Syntax Highlighter",
    link: "/ui-element/syntaxhighlighter",
    icon: "Code",
    starred: false,
  },
  {
    id: 16,
    target: "Colors",
    titleEn: "",
    titleId: "",
    title: "Colors",
    link: "/colors/colors",
    icon: "Droplet",
    starred: false,
  },
  {
    id: 17,
    target: "Icons",
    titleEn: "",
    titleId: "",
    title: "Icons",
    link: "/icons/reactfeather",
    icon: "Feather",
    starred: false,
  },
  {
    id: 18,
    target: "CardsBasic",
    titleEn: "",
    titleId: "",
    title: "Cards Basic",
    link: "/cards/basic",
    icon: "Square",
    starred: false,
  },
  {
    id: 19,
    target: "CardsStatistics",
    titleEn: "",
    titleId: "",
    title: "Cards Statistics",
    link: "/cards/statistics",
    icon: "Smartphone",
    starred: false,
  },
  {
    id: 20,
    target: "CardsAnalytics",
    titleEn: "",
    titleId: "",
    title: "Cards Analytics",
    link: "/cards/analytics",
    icon: "BarChart2",
    starred: false,
  },
  {
    id: 21,
    target: "CardsActions",
    titleEn: "",
    titleId: "",
    title: "Cards Actions",
    link: "/cards/action",
    icon: "Airplay",
    starred: false,
  },
  {
    id: 22,
    target: "ReactstrapTables",
    titleEn: "",
    titleId: "",
    title: "Reactstrap Tables",
    link: "/tables/reactstrap",
    icon: "Server",
    starred: false,
  },
  {
    id: 23,
    target: "ReactTables",
    titleEn: "",
    titleId: "",
    title: "React Tables",
    link: "/tables/react-tables",
    icon: "Server",
    starred: false,
  },
  {
    id: 24,
    target: "agGridTables",
    titleEn: "",
    titleId: "",
    title: "agGrid Tables",
    link: "/tables/agGrid",
    icon: "Grid",
    starred: false,
  },
  {
    id: 25,
    target: "Alert",
    titleEn: "",
    titleId: "",
    title: "Alert Component",
    link: "/components/alerts",
    icon: "Info",
    starred: false,
  },
  {
    id: 26,
    target: "Button",
    titleEn: "",
    titleId: "",
    title: "Button Component",
    link: "/components/buttons",
    icon: "Inbox",
    starred: false,
  },
  {
    id: 27,
    target: "Breadcrumb",
    titleEn: "",
    titleId: "",
    title: "Breadcrumb Component",
    link: "/components/breadcrumbs",
    icon: "MoreHorizontal",
    starred: false,
  },
  {
    id: 28,
    target: "Carousel",
    titleEn: "",
    titleId: "",
    title: "Carousel Component",
    link: "/components/carousel",
    icon: "Map",
    starred: false,
  },
  {
    id: 29,
    target: "Collapse",
    titleEn: "",
    titleId: "",
    title: "Collapse Component",
    link: "/components/collapse",
    icon: "Minimize",
    starred: false,
  },
  {
    id: 30,
    target: "Dropdowns",
    titleEn: "",
    titleId: "",
    title: "Dropdowns Component",
    link: "/components/dropdowns",
    icon: "Inbox",
    starred: false,
  },
  {
    id: 31,
    target: "ListGroup",
    titleEn: "",
    titleId: "",
    title: "List Group Component",
    link: "/components/list-group",
    icon: "Layers",
    starred: false,
  },
  {
    id: 32,
    target: "Modal",
    titleEn: "",
    titleId: "",
    title: "Modal Component",
    link: "/components/modals",
    icon: "Maximize2",
    starred: false,
  },
  {
    id: 33,
    target: "Pagination",
    titleEn: "",
    titleId: "",
    title: "Pagination Component",
    link: "/components/pagination",
    icon: "ChevronsRight",
    starred: false,
  },
  {
    id: 34,
    target: "Navs",
    titleEn: "",
    titleId: "",
    title: "Navs Component",
    link: "/components/nav-component",
    icon: "MoreVertical",
    starred: false,
  },
  {
    id: 35,
    target: "Navbar",
    titleEn: "",
    titleId: "",
    title: "Navbar Component",
    link: "/components/navbar",
    icon: "MoreHorizontal",
    starred: false,
  },
  {
    id: 36,
    target: "Tabs",
    titleEn: "",
    titleId: "",
    title: "Tabs Component",
    link: "/components/tabs-component",
    icon: "CreditCard",
    starred: false,
  },
  {
    id: 37,
    target: "Pills",
    titleEn: "",
    titleId: "",
    title: "Pills Component",
    link: "/components/pills-component",
    icon: "ToggleRight",
    starred: false,
  },
  {
    id: 38,
    target: "Tooltip",
    titleEn: "",
    titleId: "",
    title: "Tooltip Component",
    link: "/components/tooltips",
    icon: "MessageCircle",
    starred: false,
  },
  {
    id: 39,
    target: "Popover",
    titleEn: "",
    titleId: "",
    title: "Popover Component",
    link: "/components/popovers",
    icon: "MessageCircle",
    starred: false,
  },
  {
    id: 40,
    target: "Badge",
    titleEn: "",
    titleId: "",
    title: "Badge Component",
    link: "/components/badges",
    icon: "Circle",
    starred: false,
  },
  {
    id: 41,
    target: "PillBadge",
    titleEn: "",
    titleId: "",
    title: "Pill Badge Component",
    link: "/components/pill-badges",
    icon: "Circle",
    starred: false,
  },
  {
    id: 42,
    target: "Progress",
    titleEn: "",
    titleId: "",
    title: "Progress Component",
    link: "/components/progress",
    icon: "Server",
    starred: false,
  },
  {
    id: 43,
    target: "MediaObjects",
    titleEn: "",
    titleId: "",
    title: "Media Objects",
    link: "/components/media-objects",
    icon: "Image",
    starred: false,
  },
  {
    id: 44,
    target: "Spinner",
    titleEn: "",
    titleId: "",
    title: "Spinner Component",
    link: "/components/spinners",
    icon: "Sun",
    starred: false,
  },
  {
    id: 45,
    target: "Toasts",
    titleEn: "",
    titleId: "",
    title: "Toasts Component",
    link: "/components/toasts",
    icon: "Triangle",
    starred: false,
  },
  {
    id: 46,
    target: "Avatar",
    titleEn: "",
    titleId: "",
    title: "Avatar",
    link: "/extra-components/avatar",
    icon: "User",
    starred: false,
  },
  {
    id: 47,
    target: "Chips",
    titleEn: "",
    titleId: "",
    title: "Chips",
    link: "/extra-components/chips",
    icon: "Octagon",
    starred: false,
  },
  {
    id: 48,
    target: "Divider",
    titleEn: "",
    titleId: "",
    title: "Divider",
    link: "/extra-components/divider",
    icon: "Minus",
    starred: false,
  },
  {
    id: 49,
    target: "Select",
    titleEn: "",
    titleId: "",
    title: "Select Form Element",
    link: "/forms/elements/select",
    icon: "Server",
    starred: false,
  },
  {
    id: 50,
    target: "Switch",
    titleEn: "",
    titleId: "",
    title: "Switch Form Element",
    link: "/forms/elements/switch",
    icon: "ToggleLeft",
    starred: false,
  },
  {
    id: 51,
    target: "Checkbox",
    titleEn: "",
    titleId: "",
    title: "Checkbox Form Element",
    link: "/forms/elements/checkbox",
    icon: "CheckSquare",
    starred: false,
  },
  {
    id: 52,
    target: "Radio",
    titleEn: "",
    titleId: "",
    title: "Radio Form Element",
    link: "/forms/elements/radio",
    icon: "StopCircle",
    starred: false,
  },
  {
    id: 53,
    target: "Input",
    titleEn: "",
    titleId: "",
    title: "Input Form Element",
    link: "/forms/elements/input",
    icon: "Server",
    starred: false,
  },
  {
    id: 54,
    target: "InputGroups",
    titleEn: "",
    titleId: "",
    title: "Input Groups Form Elements",
    link: "/forms/elements/input-group",
    icon: "Package",
    starred: false,
  },
  {
    id: 55,
    target: "NumberInput",
    titleEn: "",
    titleId: "",
    title: "Number Input Form Elements",
    link: "/forms/elements/number-input",
    icon: "Plus",
    starred: false,
  },
  {
    id: 56,
    target: "Textarea",
    titleEn: "",
    titleId: "",
    title: "Textarea Form Elements",
    link: "/forms/elements/textarea",
    icon: "Edit2",
    starred: false,
  },
  {
    id: 57,
    target: "Picker",
    titleEn: "",
    titleId: "",
    title: "Date & Time Picker Form Elements",
    link: "/forms/elements/pickers",
    icon: "Calendar",
    starred: false,
  },
  {
    id: 58,
    target: "InputMask",
    titleEn: "",
    titleId: "",
    title: "Input Mask Form Elements",
    link: "/forms/elements/input-mask",
    icon: "Smile",
    starred: false,
  },
  {
    id: 59,
    target: "FormLayout",
    titleEn: "",
    titleId: "",
    title: "Form Layout",
    link: "/forms/layout/form-layout",
    icon: "Layout",
    starred: false,
  },
  {
    id: 60,
    target: "FormWizard",
    titleEn: "",
    titleId: "",
    title: "Form Wizard",
    link: "/forms/wizard",
    icon: "Sliders",
    starred: false,
  },
  {
    id: 61,
    target: "Formik",
    titleEn: "",
    titleId: "",
    title: "Formik",
    link: "/forms/formik",
    icon: "FileText",
    starred: false,
  },
  {
    id: 62,
    target: "Login",
    titleEn: "",
    titleId: "",
    title: "Login",
    link: "/pages/login",
    icon: "LogIn",
    starred: false,
  },
  {
    id: 63,
    target: "Register",
    titleEn: "",
    titleId: "",
    title: "Register",
    link: "/pages/register",
    icon: "UserPlus",
    starred: false,
  },
  {
    id: 64,
    target: "forgotPassword",
    titleEn: "",
    titleId: "",
    title: "Forgot Password",
    link: "/pages/forgot-password",
    icon: "Crosshair",
    starred: false,
  },
  {
    id: 65,
    target: "ResetPassword",
    titleEn: "",
    titleId: "",
    title: "Reset Password",
    link: "/pages/reset-password",
    icon: "TrendingUp",
    starred: false,
  },
  {
    id: 67,
    target: "LockScreen",
    titleEn: "",
    titleId: "",
    title: "Lock Screen",
    link: "/pages/lock-screen",
    icon: "Lock",
    starred: false,
  },
  {
    id: 68,
    target: "ComingSoon",
    titleEn: "",
    titleId: "",
    title: "Coming Soon",
    link: "/misc/coming-soon",
    icon: "Watch",
    starred: false,
  },
  {
    id: 69,
    target: "auth1",
    titleEn: "",
    titleId: "",
    title: "404 Page",
    link: "/misc/error/404",
    icon: "AlertTriangle",
    starred: false,
  },
  {
    id: 70,
    target: "auth2",
    titleEn: "",
    titleId: "",
    title: "500 Page",
    link: "/misc/error/500",
    icon: "AlertOctagon",
    starred: false,
  },
  {
    id: 71,
    target: "NotAuthorized",
    titleEn: "",
    titleId: "",
    title: "Not Authorized",
    link: "/misc/not-authorized",
    icon: "UserX",
    starred: false,
  },
  {
    id: 72,
    target: "Maintenance",
    titleEn: "",
    titleId: "",
    title: "Maintenance",
    link: "/misc/maintenance",
    icon: "Aperture",
    starred: false,
  },
  {
    id: 73,
    target: "Profile",
    titleEn: "",
    titleId: "",
    title: "Profile",
    link: "/pages/profile",
    icon: "Users",
    starred: false,
  },
  {
    id: 74,
    target: "",
    titleEn: "",
    titleId: "",
    title: "FAQ",
    link: "/pages/faq",
    icon: "Zap",
    starred: false,
  },
  {
    id: 75,
    target: "KnowledgeBase",
    titleEn: "",
    titleId: "",
    title: "Knowledge Base",
    link: "/pages/knowledge-base",
    icon: "AlignLeft",
    starred: false,
  },
  {
    id: 76,
    target: "Search",
    titleEn: "",
    titleId: "",
    title: "Search",
    link: "/pages/search",
    icon: "Search",
    starred: false,
  },
  {
    id: 77,
    target: "Invoice",
    titleEn: "",
    titleId: "",
    title: "Invoice",
    link: "/pages/invoice",
    icon: "FileText",
    starred: false,
  },
  {
    id: 78,
    target: "ApexCharts",
    titleEn: "",
    titleId: "",
    title: "Apex Charts",
    link: "/charts/apex",
    icon: "BarChart",
    starred: false,
  },
  {
    id: 79,
    target: "Chartjs",
    titleEn: "",
    titleId: "",
    title: "Chartjs",
    link: "/charts/chartjs",
    icon: "Activity",
    starred: false,
  },
  {
    id: 80,
    target: "recharts",
    titleEn: "",
    titleId: "",
    title: "Recharts",
    link: "/charts/recharts",
    icon: "PieChart",
    starred: false,
  },
  {
    id: 81,
    target: "Leaflet Maps",
    titleEn: "",
    titleId: "",
    title: "Leaflet Maps",
    link: "/maps/leaflet",
    icon: "MapPin",
    starred: false,
  },
  {
    id: 82,
    target: "Toastr",
    titleEn: "",
    titleId: "",
    title: "Toastr",
    link: "/extensions/toastr",
    icon: "CreditCard",
    starred: false,
  },
  {
    id: 83,
    target: "RcSlider",
    titleEn: "",
    titleId: "",
    title: "Rc Slider",
    link: "/extensions/slider",
    icon: "Sliders",
    starred: false,
  },
  {
    id: 84,
    target: "FileUploader",
    titleEn: "",
    titleId: "",
    title: "File Uploader",
    link: "/extensions/file-uploader",
    icon: "Upload",
    starred: false,
  },
  {
    id: 85,
    target: "wysiwyg-editor",
    titleEn: "",
    titleId: "",
    title: "Wysiwyg Editor",
    link: "/extensions/wysiwyg-editor",
    icon: "Edit",
    starred: false,
  },
  {
    id: 86,
    target: "DragDrop",
    titleEn: "",
    titleId: "",
    title: "Drag & Drop",
    link: "/extensions/drag-and-drop",
    icon: "Move",
    starred: false,
  },
  {
    id: 87,
    target: "Tour",
    titleEn: "",
    titleId: "",
    title: "Tour",
    link: "/extensions/tour",
    icon: "Airplay",
    starred: false,
  },
  {
    id: 88,
    target: "AutoComplete",
    titleEn: "",
    titleId: "",
    title: "Auto Complete",
    link: "/extra-components/auto-complete",
    icon: "Edit",
    starred: false,
  },
  {
    id: 89,
    target: "Clipboard",
    titleEn: "",
    titleId: "",
    title: "Clipboard",
    link: "/extensions/clipboard",
    icon: "Clipboard",
    starred: false,
  },
  {
    id: 90,
    target: "ContextMenu",
    titleEn: "",
    titleId: "",
    title: "Context Menu",
    link: "/extensions/context-menu",
    icon: "Menu",
    starred: false,
  },
  {
    id: 91,
    target: "Internationalization",
    titleEn: "",
    titleId: "",
    title: "Internationalization",
    link: "/extensions/i18n",
    icon: "Globe",
    starred: false,
  },
  {
    id: 92,
    target: "accountSettings",
    titleEn: "",
    titleId: "",
    title: "Account Settings",
    link: "/pages/account-settings",
    icon: "Settings",
    starred: false,
  },
  {
    id: 93,
    target: "userList",
    titleEn: "",
    titleId: "",
    title: "User List",
    link: "/pages/user/list",
    icon: "List",
    starred: false,
  },
  {
    id: 94,
    target: "userView",
    titleEn: "",
    titleId: "",
    title: "User View",
    link: "/pages/user/view",
    icon: "Eye",
    starred: false,
  },
  {
    id: 95,
    target: "userEdit",
    titleEn: "",
    titleId: "",
    title: "User Edit",
    link: "/app/user/edit",
    icon: "Edit",
    starred: false,
  },
  {
    id: 96,
    target: "swiper",
    titleEn: "",
    titleId: "",
    title: "Swiper",
    link: "/extensions/swiper",
    icon: "Map",
    starred: false,
  },
  {
    id: 97,
    target: "accessControl",
    titleEn: "",
    titleId: "",
    title: "Access Control",
    link: "/extensions/access-control",
    icon: "Lock",
    starred: false,
  },
  {
    id: 98,
    target: "tree",
    titleEn: "",
    titleId: "",
    title: "Tree",
    link: "/extensions/tree",
    icon: "GitMerge",
    starred: false,
  },
  {
    id: 99,
    target: "paginationExt",
    titleEn: "",
    titleId: "",
    title: "Pagination Extension",
    link: "/extensions/pagination",
    icon: "ChevronsRight",
    starred: false,
  },
  {
    id: 100,
    target: "exportExt",
    titleEn: "",
    titleId: "",
    title: "Export",
    link: "/extensions/export",
    icon: "UploadCloud",
    starred: false,
  },
  {
    id: 101,
    target: "importExt",
    titleEn: "",
    titleId: "",
    title: "Import",
    link: "/extensions/import",
    icon: "DownloadCloud",
    starred: false,
  },
  {
    id: 102,
    target: "exportSelectedExt",
    titleEn: "",
    titleId: "",
    title: "Export Selected",
    link: "/extensions/export-selected",
    icon: "CheckSquare",
    starred: false,
  },
  {
    id: 103,
    target: "listView",
    titleEn: "",
    titleId: "",
    title: "List View",
    link: "/data-list/list-view",
    icon: "List",
    starred: false,
  },
  {
    id: 104,
    target: "thumbView",
    titleEn: "",
    titleId: "",
    title: "Thumb View",
    link: "/data-list/thumb-view",
    icon: "Image",
    starred: false,
  },
  {
    id: 105,
    target: "dataTable",
    titleEn: "",
    titleId: "",
    title: "DataTable",
    link: "/tables/data-tables",
    icon: "Grid",
    starred: false,
  },
  {
    id: 106,
    target: "sweetAlert",
    titleEn: "",
    titleId: "",
    title: "Sweet Alert",
    link: "/extensions/sweet-alert",
    icon: "AlertTriangle",
  },
  {
    id: 107,
    target: "pricing",
    titleEn: "",
    titleId: "",
    title: "Pricing",
    link: "/pages/pricing",
    icon: "DollarSign",
  },
  {
    id: 108,
    target: "blogList",
    titleEn: "",
    titleId: "",
    title: "Blog List",
    link: "/pages/blog/list",
    icon: "List",
  },
  {
    id: 109,
    target: "blogDetails",
    titleEn: "",
    titleId: "",
    title: "Blog Details",
    link: "/pages/blog/details",
    icon: "FileText",
  },
  {
    id: 110,
    target: "blogEdit",
    titleEn: "",
    titleId: "",
    title: "Blog Edit",
    link: "/pages/blog/edit",
    icon: "Edit",
  },
  {
    id: 111,
    target: "fileManager",
    titleEn: "",
    titleId: "",
    title: "File Manager",
    link: "/apps/fileManager",
    icon: "Save",
  },
  {
    id: 112,
    target: "formRepeater",
    titleEn: "",
    titleId: "",
    title: "Form Repeater",
    link: "/forms/form-repeater",
    icon: "RotateCw",
  },
  {
    id: 113,
    target: "invoiceList",
    titleEn: "",
    titleId: "",
    title: "Invoice List",
    link: "/invoice/list",
    icon: "List",
  },
  {
    id: 114,
    target: "invoicePreview",
    titleEn: "",
    titleId: "",
    title: "Invoice Preview",
    link: "/invoice/preview",
    icon: "FileText",
  },
  {
    id: 115,
    target: "invoiceEdit",
    titleEn: "",
    titleId: "",
    title: "Invoice Edit",
    link: "/invoice/edit",
    icon: "Edit",
  },
  {
    id: 116,
    target: "invoiceAdd",
    titleEn: "",
    titleId: "",
    title: "Invoice Add",
    link: "/invoice/add",
    icon: "Plus",
  },
];

mock.onGet("/api/search/bookmarks/data").reply(200, {
  searchResult,
});

mock.onPost("/api/update/bookmarks").reply((request) => {
  const bookmarkToUpdate = JSON.parse(request.data).obj;

  searchResult.filter((i) => {
    if (i.id === bookmarkToUpdate.id) {
      return (i.starred = !bookmarkToUpdate.starred);
    } else {
      return null;
    }
  });
  return [200];
});
